<!-- Card do Plano -->
<div class="plano-card"
     [class.plano-card--gratuito]="ehGratuito && !existeOutroPlanoAtivo"
     [class.plano-card--contratado]="planoContratado"
     [class.plano-card--destaque]="ehDestaque"
     [class.plano-card--clicavel]="podeClicar"
     [class.plano-card--inativo]="plano.ativo === false"
     (click)="onCardClick()"
     [attr.role]="podeClicar ? 'button' : null"
     [attr.tabindex]="podeClicar ? 0 : null"
     (keydown.enter)="onCardClick()">

  <!-- Badge de destaque (POPULAR) -->
  <div *ngIf="ehDestaque" class="plano-card__badge">
    <p-tag [value]="badgeTexto" [styleClass]="'badge-destaque badge-destaque--' + badgeTipo"></p-tag>
  </div>

  <!-- Header do card -->
  <div class="plano-card__header">
    <span class="plano-card__nome">{{ plano.nome }}</span>
    <p-tag *ngIf="planoContratado"
           [value]="'planos.atual' | translate"
           severity="success">
    </p-tag>
  </div>

  <!-- Descricao -->
  <span *ngIf="plano.descricao" class="plano-card__descricao">{{ plano.descricao }}</span>

  <!-- Preco -->
  <div class="plano-card__preco-container">
    <!-- Gratuito -->
    <ng-container *ngIf="ehGratuito">
      <span class="plano-card__preco plano-card__preco--gratis">
        {{ 'planos.gratis' | translate }}
      </span>
    </ng-container>

    <!-- Pago -->
    <ng-container *ngIf="!ehGratuito">
      <!-- Preco original riscado. Precedencia contador > indicacao > periodo (D-STRIKE):
           contador/indicacao riscam o proprio plano.valor; periodo risca o valor sem desconto. -->
      <span *ngIf="temDescontoContador || temDescontoIndicacao" class="plano-card__preco-original">
        {{ plano.valor | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <span *ngIf="!temDescontoContador && !temDescontoIndicacao && temDesconto" class="plano-card__preco-original">
        {{ plano.valorOriginalSemDesconto | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <!-- Preco vigente -->
      <span class="plano-card__preco">
        {{ (temDescontoContador ? valorComDescontoContador : (temDescontoIndicacao ? valorComDescontoIndicacao : plano.valor))
            | currency:moeda:'symbol-narrow':'1.0-0':locale }}
      </span>
      <span class="plano-card__periodo">{{ labelPeriodo }}</span>
      <!-- Selo de origem do desconto do contador -->
      <p-tag *ngIf="temDescontoContador"
             [value]="labelSeloContador"
             [pTooltip]="tooltipOrigemContador"
             styleClass="plano-card__selo-contador"
             icon="pi pi-verified">
      </p-tag>
      <!-- Selo de origem do desconto de indicacao (so quando nao ha contador) -->
      <p-tag *ngIf="temDescontoIndicacao"
             [value]="labelSeloIndicacao"
             [pTooltip]="tooltipOrigemIndicacao"
             styleClass="plano-card__selo-contador"
             icon="pi pi-gift">
      </p-tag>
    </ng-container>
  </div>

  <!-- Divisor -->
  <div class="plano-card__divisor"></div>

  <!-- Features/Beneficios -->
  <div class="plano-card__features">
    <div *ngFor="let feature of featuresPlano"
         class="plano-card__feature"
         [class.plano-card__feature--inativo]="!feature.ativo">
      <i [class]="feature.icone"
         [class.feature-check]="feature.ativo"
         [class.feature-times]="!feature.ativo"
         aria-hidden="true">
      </i>
      <span>{{ feature.texto }}</span>
    </div>
  </div>

  <!-- Spacer (empurra footer para baixo) -->
  <div class="plano-card__spacer"></div>

  <!-- Footer / Acoes -->
  <div class="plano-card__footer">
    <!-- Plano contratado: info de validade + botoes -->
    <ng-container *ngIf="planoContratado && inscricaoAtiva">
      <span class="plano-card__validade">
        {{ 'planos.valido_ate' | translate }}
        {{ formatarData(inscricaoAtiva.dataDeCancelamento) }}
      </span>
      <button *ngIf="podeCancelar"
              pButton
              [label]="'planos.cancelar' | translate"
              severity="danger"
              icon="pi pi-times"
              class="p-button-sm w-full"
              (click)="onCancelar(); $event.stopPropagation()">
      </button>
      <button *ngIf="exibirRenovar"
              pButton
              [label]="'planos.renovar' | translate"
              icon="pi pi-refresh"
              class="p-button-sm p-button-outlined w-full"
              (click)="onRenovar(); $event.stopPropagation()">
      </button>
    </ng-container>

    <!-- Plano nao contratado: botao assinar ou plano atual -->
    <ng-container *ngIf="!planoContratado">
      <button *ngIf="podeClicar"
              pButton
              [label]="'planos.selecionar' | translate"
              icon="pi pi-check"
              class="w-full"
              (click)="onCardClick(); $event.stopPropagation()">
      </button>
      <button *ngIf="ehGratuito && !existeOutroPlanoAtivo"
              pButton
              [label]="'planos.plano_atual' | translate"
              class="p-button-secondary w-full"
              [disabled]="true">
      </button>
      <!-- Ha um plano pago vigente: botao informativo/desabilitado apenas para
           alinhar o rodape com os demais cards. NAO indica que o gratis e o atual. -->
      <button *ngIf="ehGratuito && existeOutroPlanoAtivo"
              pButton
              [label]="'planos.plano_gratis' | translate"
              class="p-button-secondary w-full"
              [disabled]="true">
      </button>
    </ng-container>
  </div>
</div>
